import React, { useState, useEffect } from "react";
import { FaBell } from "react-icons/fa";
import axios from "axios";
import { useUser } from "../contextProviders/userContext";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../api";

const NotificationIcon = ({ variant = "default" }) => {
  const { user } = useUser();
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const iconColor =
    error
      ? "#dc3545"
      : variant === "white"
      ? "#ffffff"
      : "var(--color-text-muted)";

  const getAuthHeader = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });

  const fetchUnreadNotifications = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/announcements?filter=unread`,
        getAuthHeader()
      );

      if (response.data && Array.isArray(response.data)) {
        const count = response.data.reduce((acc, announcement) => {
          const userRecipient = announcement.recipients.find(
            (recipient) => recipient.user === user?._id && !recipient.read
          );
          return userRecipient ? acc + 1 : acc;
        }, 0);
        setUnreadCount(count);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?._id) {
      fetchUnreadNotifications();
      const intervalId = setInterval(fetchUnreadNotifications, 30000);
      return () => clearInterval(intervalId);
    }
  }, [user?._id]);

  const handleClick = () => {
    if (user?.role === "admin") {
      navigate("/admin/announcements");
    } else {
      navigate("/announcements");
    }
  };

  return (
    <div
      onClick={handleClick}
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "36px",
        height: "36px",
        borderRadius: "var(--radius-md)",
        opacity: loading ? 0.6 : 1,
        transition: "opacity var(--transition), background var(--transition)",
        cursor: "pointer",
        background: variant === "white" ? "rgba(255,255,255,0.12)" : "transparent",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background =
          variant === "white" ? "rgba(255,255,255,0.22)" : "rgba(27,58,135,0.07)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background =
          variant === "white" ? "rgba(255,255,255,0.12)" : "transparent";
      }}
      title={error ? "Failed to load notifications" : "Go to Notifications"}>
      <FaBell style={{ fontSize: "1.2rem", color: iconColor }} />
      {unreadCount > 0 && (
        <span
          style={{
            position: "absolute",
            top: "2px",
            right: "2px",
            backgroundColor: "var(--color-red)",
            borderRadius: "50%",
            padding: "2px 5px",
            fontSize: "0.65rem",
            color: "white",
            minWidth: "16px",
            height: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            border: variant === "white" ? "1.5px solid var(--color-primary)" : "1.5px solid white",
          }}>
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </div>
  );
};

export default NotificationIcon;
